module.exports = __webpack_public_path__ + "img/back.b1e45c6d.png";